// UTM tracking utility — captures UTM params on first visit and reuses them
// across the session for lead capture (HubSpot sync, /api/leads, signup).
const STORAGE_KEY = "demandai_utm";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

/** Read UTMs from current URL. Returns object or {} if none present. */
function readUtmFromUrl() {
  if (typeof window === "undefined") return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const out = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) out[k] = v.slice(0, 200);
    });
    // referrer/landing on first touch
    if (Object.keys(out).length > 0) {
      out.landing_url = window.location.href.slice(0, 500);
      if (document.referrer) out.referrer = document.referrer.slice(0, 500);
    }
    return out;
  } catch {
    return {};
  }
}

/** Persist UTMs from current URL to sessionStorage if present (first-touch attribution). */
export function captureUtmsOnce() {
  if (typeof window === "undefined") return;
  const fresh = readUtmFromUrl();
  if (Object.keys(fresh).length === 0) return;
  // Don't overwrite an already-stored attribution unless URL has new utm_source
  const stored = getStoredUtms();
  if (stored.utm_source && !fresh.utm_source) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fresh));
  } catch {
    /* ignore */
  }
}

/** Read previously stored UTMs (sessionStorage). Returns {} if none. */
export function getStoredUtms() {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

/** Read HubSpot tracking cookie (set by HubSpot script if present). */
function readHutk() {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(/(?:^|; )hubspotutk=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

/**
 * Build standard metadata payload for /api/leads or signup `lead_metadata`.
 * Combines stored UTMs + page context + hutk.
 */
export function buildLeadMetadata(extra = {}) {
  const utm = getStoredUtms();
  const hutk = readHutk();
  const meta = {
    ...utm,
    pageUri: typeof window !== "undefined" ? window.location.href : undefined,
    pageName: typeof document !== "undefined" ? document.title : undefined,
    ...extra,
  };
  if (hutk) meta.hutk = hutk;
  // Strip undefined
  Object.keys(meta).forEach((k) => meta[k] === undefined && delete meta[k]);
  return meta;
}
